import React, { useContext } from "react";
import { AccordionContext, useAccordionButton } from "react-bootstrap";

export function ContextAwareToggle({ children, eventKey, refForDiv, clickEvent, callback }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
        eventKey,
        (ev) => {
            if (clickEvent) {
                clickEvent(ev);
            }
            callback && callback(eventKey)
        },
    );

    const isCurrentEventKey = activeEventKey === eventKey;
    return (
        <div
            className={isCurrentEventKey ? "active" : ""}
            onClick={decoratedOnClick}
            ref={refForDiv}
        >
            {children}
        </div>
    );
}
